import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { frFR } from '@mui/x-date-pickers/locales';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { fr } from 'date-fns/locale/fr';
import { ReactNode } from 'react';

const frenchLocaleText = frFR.components.MuiLocalizationProvider.defaultProps.localeText;

type Props = {
  children: ReactNode;
};

export function UIDateProvider(props: Props) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr} localeText={frenchLocaleText}>
      {props.children}
    </LocalizationProvider>
  );
}

export type { Props as UIDateProviderProps };
